<ion-header #header>
    <ion-toolbar #toolbar>
        <ion-buttons slot="primary">
            <ion-button appClick (clicked)="onClose()" #menuButton id="mainmenu-menu-button">Abbrechen</ion-button>
        </ion-buttons>
        <ion-title><span id="page-title-span">{{ 'Lieferant suchen' | translate }}</span></ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="app-content">

    <ion-searchbar [(ngModel)]="suchtext" (ionChange)="onSearchChanged($event)" (ionCancel)="onSearchChanged($event)" placeholder="{{ 'Suchen' | translate }}" #searchbar></ion-searchbar>

    <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>


    <cdk-virtual-scroll-viewport *ngIf="sichtbareItems.length" [itemSize]="88" minBufferPx="900" maxBufferPx="1350" class="ion-content-scroll-host">
        <ion-list>
            <div *cdkVirtualFor="let item of sichtbareItems; let index = index;">
                <ion-item class='artikelitem' appClick (clicked)="onAdresseSelected(item)">
                    <ion-label class="row-item-label">
                        <ion-icon *ngIf="item.istFavorit" name="star" class="favorit-icon"></ion-icon>
                        <h2>{{ item.text }}</h2>
                        <p>{{ item.subtext }}</p>
                    </ion-label>
                </ion-item>
            </div>
        </ion-list>
    </cdk-virtual-scroll-viewport>

</ion-content>